import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import EventWebinarRegistrationCard from "./EventWebinarRegistrationCard";
import EventWebinarContactAndConnect from "./EventWebinarContactAndConnect";
const EventWebinarDetailsSidebar = ({ registrationCard, socialMediaButtons, disablePrintAndShare }) => {
    return (_jsxs("aside", { children: [_jsx(EventWebinarRegistrationCard, { className: "hidden lg:block", ...registrationCard }), _jsx(EventWebinarContactAndConnect, { socialMediaButtons: socialMediaButtons, disablePrintAndShare: disablePrintAndShare, ...registrationCard })] }));
};
export default EventWebinarDetailsSidebar;
